module.exports = __webpack_public_path__ + "static/media/answerPIC2.6a87a639.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/answerPIC2.png
// module id = 1722
// module chunks = 0 1